(function (angular) {
	'use strict';

	angular.module('planVariantSelectModule', [
		'coreModule',
		'formValidationModule',
		'planModule',
		'serviceLevelModule'
	]);
})(window.angular);